import React, { FC } from 'react';
import Box from '@/components/UI/box/Box';
import Icon from '@/components/UI/icon/Icon';
import Image from 'next/image';
import useDevice from '@/hooks/useDevice';
import { getShareOptions } from '@/components/houses/housesMobile/shareDrawer/ShareDrawer';
import Typography from '@/components/UI/typography/Typography';
import styles from './ShareModal.module.scss';
type ShareIconTypes = {
  handleClose: () => void;
};
const ShareModal: FC<ShareIconTypes> = ({
  handleClose
}) => {
  const {
    isMobile
  } = useDevice();
  const shareOptions = getShareOptions(handleClose, isMobile);
  return <Box className={styles['share-modal']} data-sentry-element="Box" data-sentry-component="ShareModal" data-sentry-source-file="ShareModal.tsx">
      <Box className={styles['share-modal-header']} data-sentry-element="Box" data-sentry-source-file="ShareModal.tsx">
        <Box className={styles['share-modal-header-close']} onClick={handleClose} data-sentry-element="Box" data-sentry-source-file="ShareModal.tsx">
          <Icon name="close" type="highEmphasis" size={'large'} data-sentry-element="Icon" data-sentry-source-file="ShareModal.tsx" />
        </Box>
        <Typography variant="bodyL_Bold" data-sentry-element="Typography" data-sentry-source-file="ShareModal.tsx">اشتراک گذاری اقامتگاه</Typography>
      </Box>
      <Box className={styles['share-modal-info']} data-sentry-element="Box" data-sentry-source-file="ShareModal.tsx">
        <Typography variant="bodyM" color="neutral_700" data-sentry-element="Typography" data-sentry-source-file="ShareModal.tsx">
          این اقامتگاه را با دوستان خود به اشتراک بگذارید
        </Typography>
      </Box>
      <Box className={styles['share-modal-main']} data-sentry-element="Box" data-sentry-source-file="ShareModal.tsx">
        {shareOptions.map(({
        src,
        alt,
        text,
        action
      }, index) => <Box key={`SHARE_ITEM_${index}`} onClick={action} className={styles['share-modal-main-item']}>
            <Image width={20} height={20} src={src} alt={alt} />
            <Typography variant="bodyM">{text}</Typography>
          </Box>)}
      </Box>
    </Box>;
};
export default ShareModal;